export const FILE_EXTENSION_REGEX = /(?:\.([^.]+))?$/;

export const FILETYPE_EXTENSIONS_PHOTO = ['png', 'jpg', 'jpeg', 'heic'];
export const FILETYPE_EXTENSIONS_VIDEO = [
  'avi',
  'mov',
  'mp4',
  'mpeg',
  'mpg',
  'wmv',
];

export const PhotoFileTypes = {
  'image/png': ['.png'],
  'image/jpeg': ['.jpg', '.jpeg'],
  'image/heic': ['.heic'],
};
export const VideoFileTypes = {
  'video/mp4': ['.mp4'],
  'video/x-m4v': ['.m4v'],
  'video/quicktime': ['.mov'],
  'video/*': ['.avi', '.mov', '.mp4', '.mpeg', '.mpg', '.wmv'],
};

export const PhotoAndVideoFileTypes = {
  ...PhotoFileTypes,
  ...VideoFileTypes,
};

// File Size Limits
export const IMAGE_MAX_SIZE_BYTES = 1024 * 1024 * 50;
export const IMAGE_MAX_SIZE_MB = 50;

export const VIDEO_MAX_SIZE_BYTES = 1024 * 1024 * 100;
export const VIDEO_MAX_SIZE_MB = 100;

export const DOCUMENT_MAX_SIZE_BYTES = 1024 * 1024 * 100;
export const DOCUMENT_MAX_SIZE_MB = 100;
